import request from './data/request';
import * as types from './types';

const SHOPIFY_API_BASE_URL = window.location.origin;

export const getShopifyCart = () => {
  const url = `${SHOPIFY_API_BASE_URL}/cart.json`;
  return request.get<types.ShopifyCart | null>(url);
};

export const getToken = (params: types.GetToken) =>
  request.get<{ id_token: string; chat_id: number }>('/jwt', params, { skipToken: true });

export const getProducts = (productId: string) => {
  const url = `${SHOPIFY_API_BASE_URL}/products/${productId}.js`;
  return request.get<{ variants: { id: string }[] }>(url);
};

interface AddProductToCartProps {
  handle: string;
  variantId?: string;
  quantity: number;
  params?: { [key: string]: any };
}

export const addProductToCart = ({ variantId, handle, quantity, params }: AddProductToCartProps) => {
  const url = `${SHOPIFY_API_BASE_URL}/cart/add.js`;
  return request.post(url, {
    id: variantId || handle,
    quantity: quantity.toString(),
    ...params,
  });
};

export const addShopifyEvent = (params: types.AddShopifyEventType) => request.post('/shopify/events', params);

// TODO: once BE is ready, replace with different endpoint
export const addEvent = (params: types.AddEventType) => request.post('/shopify/events', params);

export const chatRate = (params: types.ChatRateType) => request.post('/chats/rate', params);

export const messages = (params: types.MessagesType) => request.post('/messages', params);

export const openChat = (productId: string) => request.post('/user-sessions/open-chat', { productId });

export const viewHistory = (params: types.ViewHistoryType) => request.post('/view-history', params);

export const updateSessionShopify = (params: types.SessionData) => request.put('/shopify/sessions/update', params);
